export { NewsService } from '../services/news.service';

